function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#87BBFD",
  d: "M10.6 22.9a.84.84 0 01-.7-1l1.04-4.91-3.42-1.67a3.02 3.02 0 01-1.12-4.49L14.14.2a12 12 0 10-4.19 23.63l.66-.91h-.01z"
}), React.createElement("path", {
  fill: "#556CD6",
  d: "M14.5.26L14.13.2 6.4 10.83a3.02 3.02 0 001.12 4.49l3.42 1.67 2.1-9.88 3.35 1.63a3.12 3.12 0 011.66 1.9c.27.94.08 1.9-.45 2.64l-7 9.63-.65.9v.01A12 12 0 0014.48.26"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M16.39 8.74l-3.35-1.63L9.9 21.9c-.1.47.22.95.7 1l7-9.62c.53-.74.72-1.7.45-2.63a3.13 3.13 0 00-1.66-1.9"
}))));